import { IconButton, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

interface IProps {
    onRemove: () => void;
    isDisabled: boolean;
    isSubscription: boolean;
}

const SubscriptionRemoveButton = ({ onRemove, isDisabled, isSubscription }: IProps) => {
    return (
        <Tooltip
            content={
                isSubscription && isDisabled
                    ? translate("si.management.integration.signals-api.section.webhook.min-rows-hint")
                    : translate("common.delete")
            }
            placement="top"
            delay={500}
        >
            <div>
                <IconButton
                    type="flat"
                    iconName="delete"
                    onClick={onRemove}
                    dataAutomation="delete-endpoint"
                    isDisabled={isDisabled}
                />
            </div>
        </Tooltip>
    );
};

export default SubscriptionRemoveButton;
